// Generated by `yarn tokens:import` from the Figma "typography" variables export. Do not edit.

export const typographyModes = {
    'mode-1': 'Mode 1',
} as const

export const typographyTokens = {
    'family/family': {
        alias: 'family/family',
        type: 'string',
        id: 'VariableID:6760:7979',
        scopes: ['FONT_FAMILY'],
        value: 'Manrope',
    },
    'line-height/d1': {
        alias: 'line-height/d1',
        type: 'dimension',
        id: 'VariableID:6762:8077',
        desc: "Line height for size/d1 — target ×1.2, snapped to the 4 px grid (64). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 64/52 ≈ 1.23.",
        scopes: ['LINE_HEIGHT'],
        value: 64,
    },
    'line-height/d2': {
        alias: 'line-height/d2',
        type: 'dimension',
        id: 'VariableID:6762:8078',
        desc: "Line height for size/d2 — target ×1.2, snapped to the 4 px grid (44). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 44/36 ≈ 1.22.",
        scopes: ['LINE_HEIGHT'],
        value: 44,
    },
    'line-height/d3': {
        alias: 'line-height/d3',
        type: 'dimension',
        id: 'VariableID:6762:8079',
        desc: "Line height for size/d3 — target ×1.2, snapped to the 4 px grid (40). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 40/32 = 1.25.",
        scopes: ['LINE_HEIGHT'],
        value: 40,
    },
    'line-height/d4': {
        alias: 'line-height/d4',
        type: 'dimension',
        id: 'VariableID:6765:31171',
        desc: "Line height for size/d4 — target ×1.2, snapped to the 4 px grid (28). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 28/23 ≈ 1.22.",
        scopes: ['LINE_HEIGHT'],
        value: 28,
    },
    'line-height/h1': {
        alias: 'line-height/h1',
        type: 'dimension',
        id: 'VariableID:6765:8080',
        desc: "Line height for size/h1 — target ×1.4, snapped to the 4 px grid (24). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 24/18 ≈ 1.33.",
        scopes: ['LINE_HEIGHT'],
        value: 24,
    },
    'line-height/p1': {
        alias: 'line-height/p1',
        type: 'dimension',
        id: 'VariableID:6765:8081',
        desc: "Line height for size/p1 — target ×1.5, snapped to the 4 px grid (24). Code: use this token's value (px/rem); as a unitless value the actual ratio 24/16 = 1.5 matches the target.",
        scopes: ['LINE_HEIGHT'],
        value: 24,
    },
    'line-height/p2': {
        alias: 'line-height/p2',
        type: 'dimension',
        id: 'VariableID:6765:8082',
        desc: "Line height for size/p2 — target ×1.5, snapped to the 4 px grid (20). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 20/14 ≈ 1.43.",
        scopes: ['LINE_HEIGHT'],
        value: 20,
    },
    'line-height/p3': {
        alias: 'line-height/p3',
        type: 'dimension',
        id: 'VariableID:6765:8083',
        desc: "Line height for size/p3 — target ×1.5, snapped to the 4 px grid (20). Code: use this token's value (px/rem), do not derive from the multiplier; if a unitless value is required, use the actual ratio 20/13 ≈ 1.54.",
        scopes: ['LINE_HEIGHT'],
        value: 20,
    },
    'size/d1': {
        alias: 'size/d1',
        type: 'dimension',
        id: 'VariableID:6760:8061',
        desc: 'Type scale step +10 (16 × 1.125¹⁰ → 52). Pairs with line-height/d1.',
        scopes: ['FONT_SIZE'],
        value: 52,
    },
    'size/d2': {
        alias: 'size/d2',
        type: 'dimension',
        id: 'VariableID:6760:8062',
        desc: 'Type scale step +7 (16 × 1.125⁷ → 36). Pairs with line-height/d2.',
        scopes: ['FONT_SIZE'],
        value: 36,
    },
    'size/d3': {
        alias: 'size/d3',
        type: 'dimension',
        id: 'VariableID:6760:8065',
        desc: 'Type scale step +6 (16 × 1.125⁶ → 32). Pairs with line-height/d3.',
        scopes: ['FONT_SIZE'],
        value: 32,
    },
    'size/d4': {
        alias: 'size/d4',
        type: 'dimension',
        id: 'VariableID:6765:31170',
        desc: 'Type scale step +3 (16 × 1.125³ → 23). Pairs with line-height/d4.',
        scopes: ['FONT_SIZE'],
        value: 23,
    },
    'size/h1': {
        alias: 'size/h1',
        type: 'dimension',
        id: 'VariableID:6760:8067',
        desc: 'Type scale step +1 (16 × 1.125 = 18). Pairs with line-height/h1.',
        scopes: ['FONT_SIZE'],
        value: 18,
    },
    'size/p1': {
        alias: 'size/p1',
        type: 'dimension',
        id: 'VariableID:6760:8068',
        desc: 'Base of the type scale — 16 px = 1 rem. All steps derive from it via a 1.125 (major second) ratio, rounded to whole px. Code: rem (web), sp (Android), pt + Dynamic Type (iOS).',
        scopes: ['FONT_SIZE'],
        value: 16,
    },
    'size/p2': {
        alias: 'size/p2',
        type: 'dimension',
        id: 'VariableID:6760:8069',
        desc: 'Type scale step −1 (16 × 1.125⁻¹ → 14). Pairs with line-height/p2.',
        scopes: ['FONT_SIZE'],
        value: 14,
    },
    'size/p3': {
        alias: 'size/p3',
        type: 'dimension',
        id: 'VariableID:6760:8070',
        desc: 'Type scale step −2 (16 × 1.125⁻² → 13). Pairs with line-height/p3.',
        scopes: ['FONT_SIZE'],
        value: 13,
    },
    'weight/medium': {
        alias: 'weight/medium',
        type: 'string',
        id: 'VariableID:6760:8060',
        scopes: ['FONT_STYLE'],
        value: 'Medium',
    },
    'weight/regular': {
        alias: 'weight/regular',
        type: 'string',
        id: 'VariableID:6760:8058',
        scopes: ['FONT_STYLE'],
        value: 'Regular',
    },
    'weight/semi-bold': {
        alias: 'weight/semi-bold',
        type: 'string',
        id: 'VariableID:7598:54681',
        scopes: ['FONT_STYLE'],
        value: 'SemiBold',
    },
} as const
